import React, { FC } from 'react'

import NotFoundPageIndex from '../NotFoundPage/NotFoundPageIndex'

const InternalServerErrorPageIndex: FC = () => {
  return <NotFoundPageIndex internalServerError={true} />
}

export default InternalServerErrorPageIndex
